import React from 'react';
import ReactPlayer from 'react-player';

const VideosComponent = () => {
  return (
    <div className="promo-component   d-flex flex-wrap justify-content-between">
      {videos.map(video => (
        <div className="video-box d-flex flex-column">
          <ReactPlayer width={'100%'} height={200} url={video.url} />
          <h5 className="mb-3 mt-3">{video.title}</h5>
          <p className="video-box-description">{video.description}</p>
        </div>
      ))}
    </div>
  );
};

export default VideosComponent;

const videos = [
  {
    title: 'Osnivanje Vojvodina Metal Cluster - VMC 21.10.2011',
    description: 'Reportaža sa RTV Dnevnika 1',
    url:
      'https://www.youtube.com/watch?v=_cEDnQHjstw&feature=emb_title&ab_channel=VMCCluster'
  },
  {
    title: 'Osnivačka skupština Vojvodina Metal Cluster - VMC',
    description: '14.10.2011 Radni deo, novosadski sajam, Master centar',
    url: 'https://www.youtube.com/watch?v=QCyBQNAqXCo&feature=emb_title'
  },
  {
    title: 'Prezentacija projekta Vojvodina Metal Cluster - VMC',
    description:
      'Za predstavnike partnerskih institucija Reportaža sa RTV Dnevnika 1',
    url: 'https://www.youtube.com/watch?v=331_Wh19E2M&feature=emb_title'
  },
  {
    title: 'Predstavljanje Vojvodjanskog Metal Cluster-a VMC',
    description: 'Poslovni inkubator Subotica Reportaža Info blok',
    url: 'https://www.youtube.com/watch?v=ba10G8iW7kY&feature=emb_title'
  },
  {
    title: 'Predstavljanje Vojvodjanskog Metal Cluster-a VMC',
    description: 'Stara Pazova Reportaža sa RTV Dnevnika 1',
    url: 'https://www.youtube.com/watch?v=znqS1RzbKhY&feature=emb_title'
  },
  {
    title: '01.11.2011 - Gostovanje u emisiji PRIZMA TV Kopernikus Niš',
    description:
      'Menadžer projekta - Zoran Pekez Asistent menadžer projekta - Mirjana Radenović Ratković Predsednik saveta za klastere PKS - Danka Milojković',
    url: 'https://www.youtube.com/watch?v=uKcEF63krLY&feature=emb_title'
  },
  {
    title: '01.11.2011 - Direktorka projekta BIS - Zeki Ildiko',
    description: 'Prezentacija VMC-a u Subotici',
    url: 'https://www.youtube.com/watch?v=VsDTYnkh8G0&feature=emb_title'
  },
  {
    title: '17 - 18.10.2012 - B2B Udine Italija (2. dan)',
    description:
      'Poseta članova klastera kolegama u Italiji Izjava Nenada Mićića, ICM Electronics Novi Sad (VMC član) o posetama velikim i uspešnim italijanskim firmama, i prednostima organizacije događaja ovog tipa.',
    url: 'https://www.youtube.com/watch?v=F320okrGg18&feature=emb_title'
  },
  {
    title: '17 - 18.10.2012 - B2B Udine Italija (2. dan)',
    description:
      'Poseta članova klastera kolegama u Italiji Izjava Nikole Stanivukovica, Tehnoradionica a.d. Zrenjanin (član VMC-a) o samoj organizaciji sastanaka , uspešnosti uspostavljanja kontakata kao i utisci o posetama Univerzitetu u Udinama, Laboratoriji za metalurgiju, Friuli Innovazione, i velikoj italijanskoj kompaniji Danieli.',
    url: 'https://www.youtube.com/watch?v=NvPEBzAPdBE&feature=emb_title'
  },
  {
    title: '17 - 18.10.2012 - B2B Udine Italija (1. dan)',
    description:
      "Poseta članova klastera kolegama u Italiji Prof. Slobodan Morača, Fakultet Tehničkih nauka Novi Sad (partner na projektu): 'Jedna od najuspešnijih poseta ikada organizovano. Mogućnost razvoja novih ideja kao i buduće saradnje/ nastupa na zajedničkim projektima nakon posete Univerzitetu u Udinama, i razgovora sa predstavnicima Vlade i drugih institucija.'",
    url: 'https://www.youtube.com/watch?v=7W3bwuC0QEE&feature=emb_title'
  },
  {
    title: '17 - 18.10.2012 - B2B Udine Italija (2. dan)',
    description:
      'Poseta članova klastera kolegama u Italiji Vladimir Pandurov govori o projektu VMC i značaju organizacije ovakve vrste događaja, poseta ključnim igračima u FVG regionu, o operacionalizaciji ranije potpisanog memoranduma između regiona Vojvodine i FVG.',
    url: 'https://www.youtube.com/watch?v=ajBDchhMjZY&feature=emb_title'
  },
  {
    title: '17 - 18.10.2012 - B2B Udine Italija (2. dan)',
    description:
      'Poseta članova klastera kolegama u Italiji Zoran Pekez, VMC menadžer – Prezentacija Vojvodina Metal Cluster-a u Privrednoj komori Vojvodine',
    url: 'https://www.youtube.com/watch?v=QpGX0kb5__c&feature=emb_title'
  },
  {
    title: '17 - 18.10.2012 - B2B Udine Italija (2. dan)',
    description:
      'Poseta članova klastera kolegama u Italiji Izjava Ljupka Todorovića, TODOR COLOR, Bački Jarak (član VMC-a) o poslovnim sastancima koje je imao sa italijanskim kompanijama i mogućim realizacijama u budućnosti.',
    url: 'https://www.youtube.com/watch?v=dHO0IqDwf_U&feature=emb_title'
  },
  {
    title: '17 - 18.10.2012 - B2B Udine Italija',
    description:
      'Poseta članova klastera kolegama u Italiji Zoran Pekez, projekt menadžer - Rezime rezultata dvodnevne posete italijanskim institucijama i kompanijama i poslovnim sastancima između srpskih i italijanskih firmi',
    url: 'https://www.youtube.com/watch?v=6Axf7E4-h6w&feature=emb_title'
  },
  {
    title: '3. redovna skupština VMC',
    description:
      '3. redovna skupština VMC Novi Sad (Skupština AP Vojvodine) održana je 28.02.2014',
    url: 'https://www.youtube.com/watch?v=RsQCVnJ3oFM&feature=emb_title'
  }
];
